import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=29d6910a&scoped=true"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"
import style0 from "./Listagem.vue?vue&type=style&index=0&id=29d6910a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d6910a",
  null
  
)

export default component.exports